// Which login's "since your last login" each person dismissed, kept in their browser: the
// banner and the filter it set are forgotten until their next.

const KEY = "inrange-agents.changes-seen";

const read = (): Record<string, string> => {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(KEY) ?? "{}");
    return parsed && typeof parsed === "object" ? (parsed as Record<string, string>) : {};
  } catch {
    return {};
  }
};

export const dismissedFor = (email: string, since: string): boolean => read()[email] === since;

export const rememberDismissed = (email: string, since: string): void => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...read(), [email]: since }));
  } catch {
    // Unkept, it shows again on the next load.
  }
};
